import { API_URL } from "env";
import { toast } from "react-toastify";
import { FeatureType } from "../type";

async function getAllFeatures(offset: number, limit: number): Promise<FeatureType[]> {
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/features?limit=${limit}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
        if (!data) {
            toast.error(data.message || "Failed to fetch features");
            throw new Error(data.message || "Failed to fetch features");
        }
        return data || [];
    }
    catch (error) {
        console.error("Error fetching features:", error);
        return [];
    }
}

export default getAllFeatures;